import { render, staticRenderFns } from "./FloatingFeedback.vue?vue&type=template&id=385c8f45&scoped=true"
import script from "./FloatingFeedback.vue?vue&type=script&lang=js"
export * from "./FloatingFeedback.vue?vue&type=script&lang=js"
import style0 from "./FloatingFeedback.vue?vue&type=style&index=0&id=385c8f45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c8f45",
  null
  
)

export default component.exports